import { type ProjectsForPlaylists } from 'LearnerProjects';
import { type Playlist } from 'Playlists';
import { isPassedOrWaived } from './ProjectProgress';
import { type PlaylistProgress, type useContentProgressResponse } from './ContentProgress.types';

export function getPlaylistProgress(
    playlist: Playlist,
    contentProgress: useContentProgressResponse,
    projectsForPlaylists: ProjectsForPlaylists,
): PlaylistProgress {
    const { streamProgressByLocalePackId, projectProgressByRequirementIdentifier } = contentProgress;
    const { projectsByPlaylist } = projectsForPlaylists;

    // Calculate completed streams
    const numCompletedStreams = playlist.streamEntries.filter(streamEntry => {
        const streamProgress = streamProgressByLocalePackId[streamEntry.localePackId];
        return streamProgress?.completedAt != null;
    }).length;

    // Calculate completed projects
    const playlistProjects = projectsByPlaylist[playlist.localePackId] ?? [];
    const numCompletedProjects = playlistProjects.filter(project => {
        const projectProgress = projectProgressByRequirementIdentifier[project.requirementIdentifier];
        if (!projectProgress) return false;
        return isPassedOrWaived(projectProgress);
    }).length;

    // Determine overall completion
    const numStreams = playlist.streamEntries.length;
    const numProjects = playlistProjects.length;
    const numItems = numStreams + numProjects;
    const numCompletedItems = numCompletedStreams + numCompletedProjects;
    const percentComplete = numItems === 0 ? 0 : Math.round((numCompletedItems / numItems) * 100);
    const complete = percentComplete === 100;

    return {
        numStreams,
        numProjects,
        numItems,
        numCompletedStreams,
        numCompletedProjects,
        numCompletedItems,
        complete,
        percentComplete,
    };
}
